import {
  Directive,
  HostBinding,
  Input,
  ElementRef,
  Renderer2,
} from "@angular/core";

@Directive({
  selector: "[border]",
})
export class BorderDirective {
  @Input() borderColor;
  @Input() borderWidth;
  @Input() borderStyle;
  /** input has boolean to show or hide border */
  @Input() borderWarning;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  @HostBinding("style.borderColor") get getBorderColor() {
    return this.borderColor;
  }
  @HostBinding("style.borderWidth") get getBorderWidth() {
    return this.borderWidth;
  }
  @HostBinding("style.borderStyle") get getBorderStyle() {
    return this.borderStyle;
  }
  @HostBinding("style.borderWarning") get getBorderWarning() {
    if (this.borderWarning) {
      this.renderer.setStyle(
        this.el.nativeElement,
        "border",
        "1px solid #ff2626"
      );
    } else {
      this.renderer.setStyle(this.el.nativeElement, "border", "0");
    }
    return this.borderWarning;
  }
}
